import { render, staticRenderFns } from "./actionplan-question.vue?vue&type=template&id=5ed76f57&scoped=true"
import script from "./actionplan-question.vue?vue&type=script&lang=js"
export * from "./actionplan-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed76f57",
  null
  
)

export default component.exports